export default "__VITE_ASSET__oXwL_xsU__"